<template>
    <div class="vehicle-control">
      <el-card class="control-card">
        <h2>车辆远程控制</h2>
        <el-row>
          <el-col :span="12">
            <el-switch v-model="doorStatus" active-text="开门" inactive-text="关门" @change="toggleDoor"></el-switch>
          </el-col>
          <el-col :span="12">
            <el-switch v-model="lightStatus" active-text="开灯" inactive-text="关灯" @change="toggleLight"></el-switch>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-button type="primary" @click="honkHorn">鸣笛</el-button>
          </el-col>
          <el-col :span="12">
            <el-slider v-model="airConditionerTemperature" :min="16" :max="30" :show-stops="true" :step="1" @change="setAirConditionerTemperature"></el-slider>
            <div class="temperature-label">{{ airConditionerTemperature }}°C</div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </template>
  
  <script>
  export default {
    name: 'VehicleControl',
    data() {
      return {
        doorStatus: false, // 门的状态，默认为关闭
        lightStatus: false, // 灯的状态，默认为关闭
        airConditionerTemperature: 25 // 空调温度，默认为 25°C
      };
    },
    methods: {
      toggleDoor() {
        // 模拟开关门操作，可在此处添加与后端 API 的交互逻辑
        if (this.doorStatus) {
          console.log('开门操作');
          // 这里可以调用 API 发送开门请求，例如：
          // this.$http.post('/api/door/open', {}).then(response => {...})
        } else {
          console.log('关门操作');
          // 这里可以调用 API 发送关门请求，例如：
          // this.$http.post('/api/door/close', {}).then(response => {...})
        }
      },
      toggleLight() {
        // 模拟灯光操作，可在此处添加与后端 API 的交互逻辑
        if (this.lightStatus) {
          console.log('开灯操作');
          // 这里可以调用 API 发送开灯请求，例如：
          // this.$http.post('/api/light/on', {}).then(response => {...})
        } else {
          console.log('关灯操作');
          // 这里可以调用 API 发送关灯请求，例如：
          // this.$http.post('/api/light/off', {}).then(response => {...})
        }
      },
      honkHorn() {
        // 模拟鸣笛操作，可在此处添加与后端 API 的交互逻辑
        console.log('鸣笛操作');
        // 这里可以调用 API 发送鸣笛请求，例如：
          // this.$http.post('/api/horn/honk', {}).then(response => {...})
      },
      setAirConditionerTemperature() {
        // 模拟设置空调温度操作，可在此处添加与后端 API 的交互逻辑
        console.log(`设置空调温度为 ${this.airConditionerTemperature}°C`);
        // 这里可以调用 API 发送设置温度请求，例如：
          // this.$http.post('/api/air-conditioner/temperature', { temperature: this.airConditionerTemperature }).then(response => {...})
      }
    }
  };
  </script>
  
  <style scoped>
  .vehicle-control {
    padding: 20px;
  }
  .control-card {
    width: 100%;
  }
  .temperature-label {
    text-align: center;
    margin-top: 10px;
  }
  </style>